<template>
  <UiPageTitle :title="date" :back-link="{ to: backLink }" />
</template>

<script>
import UiPageTitle from '@/components/UiPageTitle.vue'
import { mapGetters } from 'vuex'

export default {
  components: { UiPageTitle },
  props: {
    fromQuery: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      date: 'logs/currentLogDate',
    }),
    backLink() {
      return {
        name: 'logs',
        query: this.fromQuery,
      }
    },
  },
}
</script>
